module.exports = __webpack_public_path__ + "static/media/mini_logo.2844a202.png";